import { IAdsData } from '@/api/ads/interfaces';
import { useLivescoreMatch } from '@/context/LivescoreMatchContext';

const Ad = ({ attributes }: { attributes: IAdsData['data'][number]['attributes'] }) => {
  return (
    <li className="overflow-hidden rounded-xl">
      <a href={attributes.destinationUrl}>
        <picture>
          <source media="(min-width: 980px)" srcSet={attributes.desktopImage.data.attributes.url} />
          <img
            alt={attributes.mobileImage.data.attributes.alternativeText}
            src={attributes.mobileImage.data.attributes.url}
          />
        </picture>
      </a>
    </li>
  );
};

const LivescoreMatchAds = () => {
  const { ads } = useLivescoreMatch();

  return (
    <div className="space-y-2">
      <p className="sm:text-xxs text-[7px] font-semibold text-gray-400">REKLAMA</p>
      <ul className="list-none pl-0">
        {ads?.data
          ?.sort((a, b) => b.attributes.order - a.attributes.order)
          ?.map(({ id, attributes }) => <Ad key={id} attributes={attributes} />) ?? null}
      </ul>
    </div>
  );
};

export default LivescoreMatchAds;
